<form name="form" #userImportSetupForm="ngForm">
    <!-- CSV format indicator -->
    <div class="format-indicator" *ngIf="data.format">
        <strong>{{ 'Detected Format' | translate }}:</strong> 
        <span class="format-type"> {{ data.format === 'basic' ? ('Basic CSV' | translate) : ('Enhanced CSV with Domain IDs' | translate) }}</span>
    </div>

    <mon-form-field-select
        [monRequired]="true"
        [monLabel]="'Email'| translate"
        [(model)]="selected.emailIndex"
        [monOptions]="options"
        [monNameAttr]="'name'"
        [monName]="'email'"
        [monReturnValue]="'value'"
        [monPlaceholder]="'Choose an option' | translate"
        [monAllowClear]="true"
    ></mon-form-field-select>

    <mon-form-field-select
        [monRequired]="true"
        [monLabel]="'First name'| translate"
        [(model)]="selected.firstNameIndex"
        [monOptions]="options"
        [monNameAttr]="'name'"
        [monName]="'firstname'"
        [monReturnValue]="'value'"
        [monPlaceholder]="'Choose an option' | translate"
        [monAllowClear]="true"
    ></mon-form-field-select>

    <mon-form-field-select
        [monLabel]="'Last name'| translate"
        [(model)]="selected.lastNameIndex"
        [monOptions]="options"
        [monNameAttr]="'name'"
        [monName]="'lastname'"
        [monReturnValue]="'value'"
        [monPlaceholder]="'Choose an option' | translate"
        [monAllowClear]="true"
    ></mon-form-field-select>

    <mon-form-field-select
        [monLabel]="'Password'| translate"
        [(model)]="selected.passwordIndex"
        [monOptions]="options"
        [monNameAttr]="'name'"
        [monName]="'password'"
        [monHelpText]="'If none selected - a password will be generated' | translate"
        [monReturnValue]="'value'"
        [monPlaceholder]="'Choose an option' | translate"
        [monAllowClear]="true"
    ></mon-form-field-select>

    <mon-form-field-select
        [monLabel]="'Is administrator'| translate"
        [(model)]="selected.isAdminIndex"
        [monOptions]="options"
        [monNameAttr]="'name'"
        [monName]="'is_admin'"
        [monReturnValue]="'value'"
        [monPlaceholder]="'Choose an option' | translate"
        [monHelpText]="'Use Yes or No' | translate"
        [monAllowClear]="true"
    ></mon-form-field-select>

    <!-- Enhanced CSV format specific fields -->
    <div *ngIf="data?.format === 'enhanced'">
        <mon-form-field-select
            [monLabel]="'Domain IDs'| translate"
            [(model)]="selected.domainIdsColumnIndex"
            [monOptions]="options"
            [monNameAttr]="'name'"
            [monName]="'domain_ids'"
            [monReturnValue]="'value'"
            [monPlaceholder]="'Choose an option' | translate"
            [monHelpText]="'Column containing comma-separated domain IDs for each user' | translate"
            [monAllowClear]="true"
        ></mon-form-field-select>

        <mon-form-field-select
            [monLabel]="'Domain Group IDs'| translate"
            [(model)]="selected.domainGroupIdsColumnIndex"
            [monOptions]="options"
            [monNameAttr]="'name'"
            [monName]="'domain_group_ids'"
            [monReturnValue]="'value'"
            [monPlaceholder]="'Choose an option' | translate"
            [monHelpText]="'Column containing comma-separated domain group IDs for each user' | translate"
            [monAllowClear]="true"
        ></mon-form-field-select>
    </div>
</form>
